const doc = [({"en":({"js":({"admin":({"orders":({"bottom_bar":({"print_shipment_labels_for_orders_in_workplace":"Print shipment labels for orders in workplace"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;